import React, { useEffect } from "react";
import styles from "./FormulaScoreComponent.module.scss";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { useDispatch } from "react-redux";
import { setWeight } from "redux/slices/scoringSlice";


const FormulaScoreComponent = ({ handleDelete, item, initialValues = {} }) => {
    const dispatch = useDispatch();
    const largestNum = (arr) => {
        let modifiedArr = arr?.map((e) => e?.maxWeight) || [];
        return Math.max(...modifiedArr)
    };
    // useEffect(() => {
    //     if (item) {
    //         dispatch(
    //             setWeight({
    //                 type: "formula",
    //                 formulaId: item?.formulaId,
    //                 scoreType: "byFormula",
    //                 maxWeight: largestNum(item?.weights),
    //             })
    //         );
    //     }
    // }, [item]);

    return (
        <div className={styles?.scoreContainer}>
            <div className={styles?.header}>
                {
                    item?.name || "Formula"
                }
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(item.id, item?.fieldId)}
                >
                    <HighlightOffOutlinedIcon
                        sx={{ color: "#3e9ef7" }}
                        fontSize="medium"
                    />
                </span>
            </div>

        </div>
    );
};

export default FormulaScoreComponent;
